<template>
  <div>
    <v-flex xs12>
      <h2 class="text-center mb-3">Strømmåler</h2>
    </v-flex>
    <v-flex xs12 class="mb-2">
      <BooleanInput v-model="stepValues.bool" @update-fields="updateFields"></BooleanInput>
    </v-flex>
    <v-flex xs12 class="mb-3" v-if="stepValues.bool.isPowerMeter.value == 1">
      <TextInput v-model="stepValues.numbers" @update-fields="updateFields"></TextInput>
    </v-flex>
    <v-flex xs12>
      <v-checkbox v-model="stepValues.collectiveMeter" label="Kryss av her hvis strømanlegget har fellesmåling"></v-checkbox>
    </v-flex>
    <ImageUploadBox :images="stepValues.images"></ImageUploadBox>
    <StepButtons @next-page="next" @previous-page="previous" />
  </div>
</template>

<script>
import step from "../../../mixins/step";
export default {
   mixins: [step],
   beforeMount: function() {
    this.protocol.saved_values.powerOrder.powerMeter = this.stepValues
  },
};
</script>